<div class="flex-column full-width full-screen-height" fxLayoutAlign="center center">
  <div class="flex-row">
    <h1>Ooops couldn't find the the page you're looking for</h1>
    <h2>Please check the url and ensure it is correct</h2>
  </div>
  <div class="flex-row">
    <app-footer-links [inAppTabs]="false"></app-footer-links>
  </div>
</div>
